import React from 'react';
import { CommonInput } from '@/components/ui/common-input';

const TransporterProfile = ({ 
  transporterProfile, 
  errors, 
  onProfileChange 
}) => {
  return (
    <div className="">
      <div className="p-1">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <CommonInput
            label="Company Name"
            id="company_name"
            value={transporterProfile.company_name}
            onChange={(e) => onProfileChange('transporter_profile', 'company_name', e.target.value)}
            error={errors.company_name}
            required
            placeholder="Enter company name"
          />
          <CommonInput
            label="Registration Number"
            id="registration_number"
            value={transporterProfile.registration_number}
            onChange={(e) => onProfileChange('transporter_profile', 'registration_number', e.target.value)}
            error={errors.registration_number}
            required
            placeholder="Enter registration number"
          />
          <CommonInput
            label="Contact Person"
            id="contact_person"
            value={transporterProfile.contact_person}
            onChange={(e) => onProfileChange('transporter_profile', 'contact_person', e.target.value)}
            error={errors.contact_person}
            required
            placeholder="Enter contact person name"
          />
          <div className="md:col-span-2">
            <CommonInput
              label="Address"
              id="address"
              value={transporterProfile.address}
              onChange={(e) => onProfileChange('transporter_profile', 'address', e.target.value)}
              error={errors.address}
              required
              placeholder="Enter address"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default TransporterProfile;